/* eslint-disable import/prefer-default-export */
export const FINGO_MASTER_ENTITY_ID = 77201556;
